import React from "react";
import PropTypes from "prop-types";

const SidebarIcon = ({ isActive, icon }) => {
  if (!icon) return null; 
  const src = isActive ? icon.active : icon.default;

  return (
    <img
      src={src}
      alt="icon"
      className="w-5 h-5"
    />
  );
};

SidebarIcon.propTypes = {
  isActive: PropTypes.bool.isRequired,
  icon: PropTypes.shape({
    active: PropTypes.string.isRequired,
    default: PropTypes.string.isRequired
  }).isRequired
};

export default SidebarIcon;
